@import '~style-sheet-helpers/core.less';

.right-aligned {
  width: 100%;
  text-align: right;
}
